import type { TemplateData } from './template-types';

function escapeHtml(value: string): string {
  return value
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;');
}

function resolvePath(data: Record<string, unknown>, path: string): string {
  const value = path.split('.').reduce<unknown>((acc, key) => {
    if (acc && typeof acc === 'object') return (acc as Record<string, unknown>)[key];
    return undefined;
  }, data);
  if (value === undefined || value === null) return '';
  // Escapamos y convertimos saltos de línea a <br> porque campos de texto largo
  // (ej. consentimientoContenido) son el único caso multi-línea que pasa por este
  // merge-tag system; el resto de los campos son valores cortos de una línea.
  return escapeHtml(String(value)).replace(/\n/g, '<br>');
}

function replaceSimpleTags(html: string, data: Record<string, unknown>): string {
  return html.replace(/\{\{\s*([a-zA-Z0-9_]+(?:\.[a-zA-Z0-9_]+)*)\s*\}\}/g, (match, path: string) => {
    if (path.startsWith('item.')) return match; // se resuelve al expandir el loop
    return resolvePath(data, path);
  });
}

function expandLoops(doc: Document, data: TemplateData): void {
  const loopEls = Array.from(doc.querySelectorAll('[data-loop]'));
  for (const el of loopEls) {
    const campo = el.getAttribute('data-loop') || '';
    const items = (data as unknown as Record<string, unknown[]>)[campo];
    const parent = el.parentNode;
    if (!parent) continue;

    if (!Array.isArray(items) || items.length === 0) {
      parent.removeChild(el);
      continue;
    }

    for (const item of items) {
      const clone = el.cloneNode(true) as HTMLElement;
      clone.removeAttribute('data-loop');
      clone.innerHTML = replaceSimpleTags(clone.innerHTML, item as Record<string, unknown>).replace(
        /\{\{\s*item\.([a-zA-Z0-9_]+)\s*\}\}/g,
        (_match, key: string) => resolvePath(item as Record<string, unknown>, key),
      );
      parent.insertBefore(clone, el);
    }
    parent.removeChild(el);
  }
}

/** Convierte el HTML exportado de Unlayer (con tags {{...}} y filas [data-loop]) en HTML final con los datos reales. */
export function renderPersonalizadaHtml(html: string, data: TemplateData): string {
  if (!html) return '';

  const parser = new DOMParser();
  const doc = parser.parseFromString(html, 'text/html');
  expandLoops(doc, data);

  const expanded = doc.body.innerHTML;
  return replaceSimpleTags(expanded, data as unknown as Record<string, unknown>);
}
